import { Container, Typography, Paper } from '@mui/material'

const Ideas = () => {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        💡 Ideas
      </Typography>

      <Paper sx={{ p: 2 }}>
        Idea list will come here...
      </Paper>
    </Container>
  )
}

export default Ideas
